import { create } from "zustand";
import { GeoJsonFeatureOfRoutePartOfRoadFeatures, GeoJsonGeometry, PointRoadFeature } from "../services/RuteplanAPI";

export interface IRoutingHighlightActions {
    setFeature: (feature: GeoJsonFeatureOfRoutePartOfRoadFeatures | null ) => void;
    setClickedFeature: (feature: GeoJsonFeatureOfRoutePartOfRoadFeatures ) => void;
    setRouteDescriptionHighlightFeature: (feature: PointRoadFeature | null) => void;
    setRoadFeatureHighlightLine: (geometry: GeoJsonGeometry | null) => void;
}

export interface IRoutingHighlightState {
    feature: GeoJsonFeatureOfRoutePartOfRoadFeatures | null;
    clickedFeature: GeoJsonFeatureOfRoutePartOfRoadFeatures | null;
    routeDescriptionHighlightFeature:  PointRoadFeature | null;
    roadFeatureHighlightLine: GeoJsonGeometry | null;
    actions: IRoutingHighlightActions;
}

const useRouteHighlightStore = create<IRoutingHighlightState>( (set) => ({
    feature: null,
    clickedFeature: null,
    routeDescriptionHighlightFeature: null,
    roadFeatureHighlightLine: null,
    actions:  {
        setFeature: (feature: GeoJsonFeatureOfRoutePartOfRoadFeatures | null) => {
            set({feature: feature});
        },
        setClickedFeature: (feature: GeoJsonFeatureOfRoutePartOfRoadFeatures) => {
            set({clickedFeature: feature});
        },
        setRouteDescriptionHighlightFeature: (feature: PointRoadFeature | null) => {
          set({routeDescriptionHighlightFeature: feature});
        },
        setRoadFeatureHighlightLine: (geometry: GeoJsonGeometry | null) => {
            set({roadFeatureHighlightLine: geometry})
        }
    }
}));

export const useHighlightFeature = () => useRouteHighlightStore((state) => state.feature);
export const useRouteDescriptionHighlightFeature = () => useRouteHighlightStore((state) => state.routeDescriptionHighlightFeature);
export const useClickedFeature = () => useRouteHighlightStore((state) => state.clickedFeature);
export const useRoadFeatureHighlightLine = () => useRouteHighlightStore((state) => state.roadFeatureHighlightLine);
export const useRouteHighlightActions = () => useRouteHighlightStore((state) => state.actions);